module.exports = __webpack_public_path__ + "img/excavating_machinery-icon0.c679e61d.png";